import { useGetProjectAssetLifecyclePolicyQuery } from '../gql/queries/generated/GetProjectAssetLifecyclePolicy';

export const useProjectAssetLifecyclePolicy = (projectId: string) => {
  const { data, loading } = useGetProjectAssetLifecyclePolicyQuery({
    variables: {
      projectId,
    },
    skip: typeof projectId !== 'string' || projectId === '',
  });

  return {
    isExempt: data?.account?.project?.ignoreArchive ?? null,
    workspace: data?.account?.project?.workspace ?? {
      daysBeforeAssetAutoDeletion: 0,
    },
    loading,
  };
};
